import { SelectFilter } from '@agro-club/agroclub-shared'
import { useAnalyticsChangeHandler } from 'analytics/hooks'
import env from 'env'
import { ListRequestParams } from 'modules/domain/types'
import { FC, SetStateAction } from 'react'
import { useTranslation } from 'react-i18next'

const currency = env.REACT_APP_CURRENCY_SYMBOL

type Props = {
  listRequestParams: ListRequestParams
  tabSetter: React.Dispatch<SetStateAction<ListRequestParams>>
}

export const DashboardSortFilter: FC<Props> = ({ listRequestParams, tabSetter }) => {
  const { t } = useTranslation('dashboard')
  const analyticsChangeHandler = useAnalyticsChangeHandler('dashboardSortFilter')

  const options = [
    { label: `${t('marginDesc')} %`, value: '-deal_margin_percent' },
    { label: `${t('marginDesc')} ${currency}`, value: '-deal_margin' },
    { label: t('gmvDesc'), value: '-deal_gmv' },
  ]

  const value = listRequestParams.sort

  const onChange = analyticsChangeHandler(
    (sort) => {
      tabSetter({ ...listRequestParams, sort })
    },
    {
      value: { from: value },
    },
  )

  return (
    <SelectFilter
      placeholder={t('sortFilter.placeholder')}
      options={options}
      onChange={onChange}
      value={value}
      showSearch={false}
    />
  )
}
